import { cn } from '~/utils/cn';
import { riskLabel } from '~/utils/contractLabels';
import type { RiskLevel } from '~/store/contracts/interfaces';

import { Text } from '../Text/view';

interface PropsRiskChip {
  level: RiskLevel;
  className?: string;
  compact?: boolean;
}

const STYLE: Record<RiskLevel, { bg: string; text: string }> = {
  low: { bg: 'bg-success-01', text: 'color-success-07' },
  medium: { bg: 'bg-alert-01', text: 'color-alert-06' },
  high: { bg: 'bg-warning-01', text: 'color-warning-06' },
};

export default function RiskChip({ level, className, compact }: PropsRiskChip) {
  const { bg, text } = STYLE[level];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-quark rounded-full',
        bg,
        compact ? 'px-nano py-[2px]' : 'px-smaller py-quark',
        className,
      )}
    >
      <Text className={cn('text-captionLG', text)}>{riskLabel(level)}</Text>
    </span>
  );
}
